function Afghanistan({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_460)">
        <path d="M22.9565 1.58763C20.853 0.5705 18.4932 0 16 0C13.5069 0 11.147 0.5705 9.04353 1.58763L7.65222 16L9.04353 30.4124C11.147 31.4295 13.5069 32 16 32C18.4932 32 20.853 31.4295 22.9565 30.4124L24.3478 16L22.9565 1.58763Z" fill="#D80027"/>
        <path d="M9.0435 1.58813C3.69163 4.17607 0 9.65663 0 15.9999C0 22.3433 3.69163 27.8238 9.0435 30.4117V1.58813Z" fill="black"/>
        <path d="M22.9565 1.58813V30.4117C28.3084 27.8238 32 22.3433 32 15.9999C32 9.65663 28.3084 4.17607 22.9565 1.58813Z" fill="#496E2D"/>
        <path d="M16 10.4348C12.9264 10.4348 10.4348 12.9264 10.4348 16C10.4348 19.0736 12.9264 21.5652 16 21.5652C19.0736 21.5652 21.5652 19.0736 21.5652 16C21.5652 12.9264 19.0736 10.4348 16 10.4348ZM16 19.4783C14.079 19.4783 12.5218 17.9209 12.5218 16C12.5218 14.0791 14.0791 12.5218 16 12.5218C17.9209 12.5218 19.4783 14.0791 19.4783 16C19.4783 17.9209 17.921 19.4783 16 19.4783Z" fill="#FFDA44"/>
        <path d="M16 13.9131C15.2315 13.9131 14.6086 14.536 14.6086 15.3044V17.3913H17.3913V15.3044C17.3913 14.536 16.7684 13.9131 16 13.9131Z" fill="#FFDA44"/>
      </g>
    </svg>

  `;

  return baseXml;
}

export default Afghanistan;
